export default class SuccessListTopic {
    public normalizedName: string | 'LEGACY' | 'OVERVIEW';
    public localizedName: string;
    public nameListEntryCount: number;
    public nameListEntryIds: string[];
    public sortOrder: number;

    constructor(json: any) {
        this.normalizedName = json.normalizedName;
        this.localizedName = json.localizedName;
        this.nameListEntryCount = json.nameListEntryCount;
        this.nameListEntryIds = json.nameListEntryIds;
        this.sortOrder = json.sortOrder;
    }
}
